export const PLAN_BUTTON_DEFAULTS = {
  snapshot: {
    free: "common.get-started",
    starter: "common.start-free-trial",
    growth: "common.start-free-trial",
    advanced: "common.start-free-trial",
    ultimate: "common.start-free-trial",
  },
  standard: {
    free: "common.get-started",
    starter: "common.try-free",
    growth: "common.try-free",
    advanced: "common.try-free",
    ultimate: "common.try-free",
  },
}

